// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_15iW1","heading":"_3cOeA"};